import { lazy, Suspense } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Lazy-loaded like the booking report: a Tollit-only finance screen that no
 * other role should download. Kept in its own file so router.tsx's Fast
 * Refresh boundary stays just the route table.
 */
const InvoicingScreen = lazy(() =>
  import('@/screens/finance/invoicing/InvoicingScreen').then((module) => ({
    default: module.InvoicingScreen,
  })),
);

function InvoicingFallback() {
  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}

export function LazyInvoicingScreen() {
  return (
    <Suspense fallback={<InvoicingFallback />}>
      <InvoicingScreen />
    </Suspense>
  );
}
